export default __webpack_public_path__ + "images/measurement.5df96b20637f60e9f97be2cea151869b.png";